 
export const BaseURL = "https://blog-app-backend-v3ca.onrender.com/api/v1"; 
export const NavLinks = [
    {link:"Home",id:"001",path:"/"},
    {link:"Blog Posts",id:"002",path:'/blog-posts'},
    {link:"Projects",id:"003",path:'/'}
]; 
